// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container--fullHeight {
    height: 100%;
}
.container--hidden {
    display: none;
}
.container__toolBar {
    overflow: hidden;
    display: inline-flex;
    top: 0;
    width: 100%;
    height: 20px;
    background: linear-gradient(to bottom, #ffffff 0%, #e5e9ee 100%);
    display: flex;
    padding: 3px 5px;
}
.container__pointerIcon {
    cursor: pointer;
}
.container__toolBar--rightAligned {
    justify-content: end;
}
.grid {
    margin-top: 0;
}
.grid__item {
}
.grid__item--fullHeight {
    height: 100%;
}

.list--scrollable {
    height: 100%;
    overflow: auto;
}
.stack--fixed900 {
    height: 900px;
    width: 100%;
}
.popupContainer {
}
.popupContainer--fullWindow {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1300;
    margin-top: 0 !important;
}

.scrollTopBtn {
    position: fixed;
    right: 2rem;
    bottom: 2rem;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/components.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gEAAgE;IAChE,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;AACA;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;AACA;IACI,aAAa;IACb,WAAW;AACf;AACA;AACA;AACA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container--fullHeight {\n    height: 100%;\n}\n.container--hidden {\n    display: none;\n}\n.container__toolBar {\n    overflow: hidden;\n    display: inline-flex;\n    top: 0;\n    width: 100%;\n    height: 20px;\n    background: linear-gradient(to bottom, #ffffff 0%, #e5e9ee 100%);\n    display: flex;\n    padding: 3px 5px;\n}\n.container__pointerIcon {\n    cursor: pointer;\n}\n.container__toolBar--rightAligned {\n    justify-content: end;\n}\n.grid {\n    margin-top: 0;\n}\n.grid__item {\n}\n.grid__item--fullHeight {\n    height: 100%;\n}\n\n.list--scrollable {\n    height: 100%;\n    overflow: auto;\n}\n.stack--fixed900 {\n    height: 900px;\n    width: 100%;\n}\n.popupContainer {\n}\n.popupContainer--fullWindow {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 1300;\n    margin-top: 0 !important;\n}\n\n.scrollTopBtn {\n    position: fixed;\n    right: 2rem;\n    bottom: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
